import $ from "jquery";
import axios from "axios";
import _ from "lodash";

$(function () {
    var paymentCheck = {
        interval: function (url) {
            const _self = this;
            _self.check(url);
            setInterval(_self.check.bind(_self, url), 10000);
        },
        init: function () {
            const _self = this,
                checkContainer = $('.payment-check[data-check-url]');

            if (checkContainer.length) {
                const url = checkContainer.attr('data-check-url');
                if (typeof url !== 'undefined') {
                    _self.interval(url);
                }
            }
        },
        check: function (url) {
            const _self = this,
                checkContainer = $('.payment-check[data-check-url]');

            axios
                .get(url)
                .then(function (response) {
                    console.log(response);
                    checkContainer.html(response.data);
                    _self.interval = function () {
                        return false;
                    };
                })
                .catch(function (error) {
                    console.log(error.response);
                    checkContainer.html(error.response.data);
                });

        }
    }.init();

    let checkout = {
        form: undefined,

        init: function () {
            this.form = $('#checkout-form');
            this.nextStep();
        },

        enableButton: function (btn) {
            btn.removeClass('btn-disabled').prop('disabled', false).show();
        },

        disabledButton: function (btn) {
            btn.addClass('btn-disabled').prop('disabled', true).hide();
        },

        // Инициализация после получения этапа «Адреса»
        stepCustomer: function () {
            const _self = this,
                step = _self.form.find('[data-step="customer"]');

            if (step.find('.delivery-block').length) {
                _self.enableButton(step.find('.btn-next-step'));
            }
        },

        // Инициализация после получения этапа «Адреса»
        stepAddress: function () {
            const _self = this,
                step = _self.form.find('[data-step="address"]');

            if (step.find('.delivery-block').length) {
                _self.enableButton(step.find('.btn-next-step'));
            }
        },

        // Инициализация после получения этапа «Доставки»
        stepDelivery: function () {
            const _self = this,
                step = _self.form.find('[data-step="delivery"]');

            $('body').on('change', step.find('[name="delivery_method_id"]'), function () {
                _self.enableButton(step.find('.btn-next-step'));
                var label = $('[name="delivery_method_id"]:checked').next('.custom-control-label'),
                    price = label.find('.price'),
                    name = label.find('.name');

                // console.log(label, price, name);

                var total = $('.checkout-total-price strong');
                total.text(parseFloat(parseFloat(total.data('total')) + parseFloat(price.data('price'))).toFixed(2) + " €");

                if (!price.hasClass('free')) {
                    $('#checkout-delivery').show();
                    $('#checkout-delivery').html('<p>' + name.text() + '</p><strong>' + price.text() + '</strong>');
                } else {
                    $('#checkout-delivery').hide();
                }
            });
        },

        // Инициализация после получения этапа «Оплаты»
        stepPayment: function () {
            const _self = this,
                step = _self.form.find('[data-step="payment"]');

            $('body').on('change', step.find('[name="payment_method_id"]'), function () {
                _self.enableButton(step.find('.btn-next-step'));
            });
        },

        // Инициализация после получения этапа «Комментарии»
        stepComments: function () {
            this.enableButton($('.checkout-total .btn[type="submit"]'));
        },

        convertName: function (name) {
            return _.reduce(_.split(name, '.'), (result, value) => result.length ? result + '[' + value + ']' : value);
        },

        // Единая функция для навигации между шагами
        nextStep: function () {
            const _self = this;

            // При клике на кнопку следующего шага
            $('body').on('click', '.btn-next-step', function (e) {
                e.preventDefault();

                const btn = $(this),
                    nextStep = btn.attr('data-next-step'),
                    insertAfter = btn.parents('.checkout-block');

                // Проверяем, не грузится ли в данный момент
                if (btn.hasClass('btn-loading')) {
                    console.log('Step is already loading');
                    return false;
                }

                // Проверяем не заблокирована ли кнопка
                if (btn.prop('disabled') || btn.hasClass('btn-disabled')) {
                    console.log('Can not load next step');
                    return false;
                }

                // Проверяем, существует ли атрибут следующего шага
                if (typeof nextStep === 'undefined') {
                    console.log('Next step is not specified');
                    return false;
                }

                // Добавляем класс загрузки
                btn.addClass('btn-loading');

                // Удаляем существующие версии этого шага
                $('[data-step="' + nextStep + '"]').remove();

                // Контейнеры: 
                // — коллбэк при успешной загрузке шага TODO: remove
                let callbackSuccess;

                switch (nextStep) {
                    case 'customer':
                        callbackSuccess = _self.stepCustomer;
                        break;
                    case 'address':
                        callbackSuccess = _self.stepAddress;
                        break;
                    case 'delivery':
                        callbackSuccess = _self.stepDelivery;
                        break;
                    case 'payment':
                        callbackSuccess = _self.stepPayment;
                        break;
                    case 'comments':
                        callbackSuccess = _self.stepComments;
                    default:
                        break;
                }
                if(callbackSuccess) {
                    callbackSuccess = callbackSuccess.bind(_self);
                }
                axios
                    .post(route('catalog.checkout.step', nextStep), _self.form.serializeObject())
                    .then(function (response) {
                        $(response.data).insertAfter(insertAfter);
                        btn.remove();
                        callbackSuccess();
                    })
                    .catch(function (error) {
                        if (typeof error.response.data.errors !== 'undefined') {
                            _.forEach(error.response.data.errors, (err, name) => {
                                if (typeof err !== 'string' && err.length) {
                                    name = _self.convertName(name);
                                    err = _.reduce(err, (result, value) => {
                                        return result === '' ? value : result + "\n" + value;
                                    });
                                    console.log(name, err);
                                    const field = _self.form.find('[name="' + name + '"]');
                                    field.addClass('is-invalid')
                                        .next('.invalid-feedback')
                                        .remove()
                                        .end()
                                        .after($('<div></div>', {class: 'invalid-feedback'}).text(err))
                                        .one('keyup change', () => {
                                            field.removeClass('is-invalid')
                                                .next('.invalid-feedback')
                                                .remove();
                                        })
                                }
                            });
                        } else {
                            console.log(error, error.response);
                        }
                    })
                    .then(function () {
                        btn.removeClass('btn-loading');
                    });

            });
        }
    }.init();
});


// WEBPACK FOOTER //
// ./resources/assets/js/modules/checkout.js